import { parseISO } from 'date-fns';
import some from 'lodash/some';
import {
  BookingRequestRead,
  BookingRequestReadStatusEnum,
  StatusByProviderEnum,
  StatusByRepEnum,
} from '../../../api';

export const respondAction = 'Respond to Assignment';
export const updateAction = 'Update Assignment';
export const confirmAction = 'Confirm Assignment';

export const StatusColor = {
  [BookingRequestReadStatusEnum.PENDING]: '',
  [BookingRequestReadStatusEnum.RESPONDED]: 'fw-semibold',
  [BookingRequestReadStatusEnum.CONFIRMED]: 'text-success fw-semibold',
  [BookingRequestReadStatusEnum.CANCELED]: 'text-danger fw-semibold',
  [StatusByProviderEnum.ACCEPTED]: 'text-success fw-semibold',
  [StatusByProviderEnum.REJECTED]: 'text-danger fw-semibold',
};

export const convertBookingRequestFormToApi = (userIsProvider: boolean, data: any) => {
  return {
    bookings: data?.bookings?.map((booking: any) => {
      if (userIsProvider) {
        return {
          id: booking.id,
          status_by_provider: booking.status_by_provider
            ? StatusByProviderEnum.ACCEPTED
            : StatusByProviderEnum.REJECTED,
        };
      }
      return {
        id: booking.id,
        status_by_rep: booking.status_by_rep ? StatusByRepEnum.ACCEPTED : StatusByRepEnum.REJECTED,
      };
    }),
    comment: data.comment,
  };
};

export const getSubmitAction = (bookingRequest: BookingRequestRead, userIsProvider: boolean) => {
  if (userIsProvider && bookingRequest.status === BookingRequestReadStatusEnum.PENDING) {
    return respondAction;
  }
  if (userIsProvider && bookingRequest.status === BookingRequestReadStatusEnum.RESPONDED) {
    return updateAction;
  }
  if (!userIsProvider && bookingRequest.status === BookingRequestReadStatusEnum.PENDING) {
    return updateAction;
  }

  if (
    !userIsProvider &&
    bookingRequest.status === BookingRequestReadStatusEnum.RESPONDED &&
    some(bookingRequest.bookings, (b) => b.status_by_provider === StatusByProviderEnum.ACCEPTED)
  ) {
    return confirmAction;
  }
};

export const getAllowShiftEdit = (
  booking: BookingRequestRead['bookings'][0],
  userIsProvider: boolean,
  bookingRequest: BookingRequestRead
) => {
  if (!userIsProvider) {
    return (
      ![
        BookingRequestReadStatusEnum.CONFIRMED,
        BookingRequestReadStatusEnum.CANCELED,
        BookingRequestReadStatusEnum.PENDING,
      ].includes(bookingRequest.status) &&
      parseISO(booking.start_on) > new Date() &&
      booking.status_by_provider !== StatusByProviderEnum.REJECTED
    );
  }
  return (
    ![BookingRequestReadStatusEnum.CONFIRMED, BookingRequestReadStatusEnum.CANCELED].includes(
      bookingRequest.status
    ) && parseISO(booking.start_on) > new Date()
  );
};

export const getAllowUpdates = (bookingRequest: BookingRequestRead, userIsProvider: boolean) => {
  return (
    ![BookingRequestReadStatusEnum.CONFIRMED, BookingRequestReadStatusEnum.CANCELED].includes(
      bookingRequest.status
    ) &&
    (userIsProvider ||
      (!userIsProvider && bookingRequest.status !== BookingRequestReadStatusEnum.PENDING))
  );
};

export const getAllBookingsInPast = (bookings: BookingRequestRead['bookings']) => {
  return !(parseISO(bookings[bookings.length - 1].start_on) >= new Date());
};

export const getAllowCancel = (
  bookings: BookingRequestRead['bookings'],
  bookingRequestStatus: BookingRequestReadStatusEnum
) => {
  const thirtyDaysFromNow = new Date();
  thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + 30);

  return (
    ((parseISO(bookings[bookings.length - 1].start_on) > thirtyDaysFromNow &&
      bookingRequestStatus === BookingRequestReadStatusEnum.CONFIRMED) ||
      bookingRequestStatus !== BookingRequestReadStatusEnum.CONFIRMED) &&
    bookingRequestStatus !== BookingRequestReadStatusEnum.CANCELED
  );
};
